import { render, staticRenderFns } from "./BrokerForm.vue?vue&type=template&id=e57c7d3a&scoped=true&"
import script from "./BrokerForm.vue?vue&type=script&lang=js&"
export * from "./BrokerForm.vue?vue&type=script&lang=js&"
import style0 from "./BrokerForm.vue?vue&type=style&index=0&id=e57c7d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57c7d3a",
  null
  
)

export default component.exports